import { CampaignType } from "../../../utils/enums";

export const mergeTags = [
    {
      label: "First Name",
      value: "{{firstname}}",
      type: "Email-SMS"
    },
    {
      label: "Last Name",
      value: "{{lastname}}",
      type: "Email-SMS"
    },
    {
      label: "Phone Number",
      value: "{{phone_number}}",
      type: "Email-SMS"
    },    
    {
      label: "Address",
      value: "{{address}}",
      type: "Email-SMS"
    },    
    {
      label: "City",
      value: "{{city}}",
      type: "Email-SMS"
    },
    {
      label: "State",
      value: "{{state}}",
      type: "Email-SMS"
    },
    {
      label: "Zipcode",
      value: "{{zipcode}}",
      type: "Email-SMS"
    },
    {
      label: "Email",
      value: "{{email}}",
      type: "Email-SMS"
    },
    {
      label: "DOB",
      value: "{{DOB}}",
      type: "Email-SMS"
    },
    {
      label: "Location Name",
      value: "{{location_name}}",
      type: "Email-SMS"
    },
    {
      label: "Location Logo",
      value: "{{location_logo}}",
      type: CampaignType.EMAIL
    },
    {
      label: "Unsubscribe Link",
      value: "{{unsubscribeURL}}",
      type: CampaignType.EMAIL
    }
  ]

export const rssMergeTags = [
  {
    label: "Default RSS Feed Block",
    value: "{{rss_content}}",
    type: CampaignType.EMAIL
  },
  {
    label: "RSS Feed Title",
    value: "{{rss_feed_title}}",
    type: CampaignType.EMAIL
  },
  {
    label: "RSS Feed Link",
    value: "{{rss_feed_link}}",
    type: CampaignType.EMAIL
  },
  {
    label: "RSS Feed Image",
    value: "{{rss_feed_image}}",
    type: CampaignType.EMAIL
  },
  {
    label: "RSS Item Title",
    value: "{{rss_title}}",
    type: CampaignType.EMAIL
  },
  {
    label: "RSS Item Link",
    value: "{{rss_link}}",
    type: CampaignType.EMAIL
  },
  {
    label: "RSS Item Description",
    value: "{{rss_description}}",
    type: CampaignType.EMAIL
  },
  {
    label: "RSS Item Image",
    value: "{{rss_image}}",
    type: CampaignType.EMAIL
  },
  {
    label: "RSS Item Date",
    value: "{{rss_date}}",
    type: CampaignType.EMAIL
  },
  {
    label: "RSS Inner Title",
    value: "{{rss_inner_title}}",
    type: CampaignType.EMAIL
  },
  {
    label: "RSS Inner Image",
    value: "{{rss_inner_image}}",
    type: CampaignType.EMAIL
  },
  {
    label: "RSS Inner Description",
    value: "{{rss_inner_description}}",
    type: CampaignType.EMAIL
  },
]
